module.exports = "static/assets/941e6fd45098f1afcee8852033e2978f.svg";